export default __webpack_public_path__ + "fonts/form_2.22db362ed60146463b2f30260dbbe871.png";